import mergeClasses from '../../../utils/shallowMerge';
import { CloseMinus, Plus } from '../../atoms/icons';
import defaultClasses from './Accordion.module.scss';
import clsx from 'clsx';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

export const AccordionTitle = (props) => {
  const {
    children,
    isSectionOpen = false,
    handleSectionToggleWithId = null,
    id = '0',
    isRotate = false,
    timeout = 20,
    customClasses = null,
    iconToOpen: IconOpen,
    iconToClose: IconClose,
    ...rest
  } = props;
  const styles = mergeClasses(defaultClasses, customClasses);

  const defaultProps = isSectionOpen ? (
    isRotate ? (
      <CSSTransition timeout={timeout} className={`${styles.crossRotate}`}>
        {IconOpen ? <IconOpen /> : <Plus />}
      </CSSTransition>
    ) : IconClose ? (
      <IconClose />
    ) : (
      <CloseMinus />
    )
  ) : IconOpen ? (
    <IconOpen />
  ) : (
    <Plus />
  );

  return (
    <div
      tabIndex="0"
      className={clsx(styles.title, styles.customTitle)}
      aria-expanded={isSectionOpen}
      aria-controls={`title_${id}`}
      id={`title_${id}`}
      onClick={handleSectionToggleWithId}
      role="button"
      {...rest}
    >
      <div className={styles.content}>{children}</div>
      {defaultProps}
    </div>
  );
};
